/**
 * Format a "YYYY-MM-DD" or "YYYY-MM" period date for display.
 *
 * Three different formatPeriod helpers had drifted across documents/index,
 * customer-cost-history-tab, and the dashboard — one used Intl, one hand-rolled
 * an abbreviated-month array, and the third hand-rolled a full-month one. This
 * unifies them.
 */
export function formatPeriod(periodDate: string | null, opts?: { short?: boolean }): string {
	if (!periodDate) return "\u2014";
	const [year, month] = periodDate.split("-");
	if (!year || !month) return periodDate;
	const date = new Date(Number(year), Number(month) - 1);
	return date.toLocaleDateString("en-US", {
		month: opts?.short ? "short" : "long",
		year: "numeric",
	});
}
